import  {eXcell,__extends} from './eXcell';
import eXcell_combo from "./eXcell_combo";



var eXcell_cp = (function (_super) {
    __extends(eXcell_cp, _super);
    function eXcell_cp(a) {
        _super.call(this);
        try {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
        catch (c) { }
    }
    eXcell_cp.prototype.edit = function () {
        this.val = this.getValue();
        this.obj = document.createElement("SPAN");
        this.obj.style.border = "1px solid black";
        this.obj.style.position = "absolute";
        var e = this.grid.getPosition(this.cell);
        this.colorPanel(4, this.obj);
        document.body.appendChild(this.obj);
        this.obj.style.left = e[0] + "px";
        this.obj.style.zIndex = 1000;
        this.obj.style.top = e[1] + this.cell.offsetHeight + "px";
    };
    eXcell_cp.prototype.toolDNum = function (e) {
        if (e.length == 1) {
            e = "0" + e;
        }
        return e;
    };
    eXcell_cp.prototype.colorPanel = function (s, w) {
        var m = document.createElement("TABLE");
        w.appendChild(m);
        m.cellSpacing = 0;
        m.editor_obj = this;
        m.style.cursor = "default";
        m.onclick = function (y) {
            var x = y || window.event;
            var n = x.target || x.srcElement;
            var r = n.parentNode.parentNode.parentNode.editor_obj;
            if (r) {
                r.setValue(n._bg);
                r.grid.editStop();
            }
        };
        var h = 256 / s;
        for (var l = 0; l <= 256 / h; l++) {
            var e = m.insertRow(l);
            for (var o = 0; o <= 256 / h; o++) {
                for (var g = 0; g <= 256 / h; g++) {
                    var R = Number(h * l) - (l == 0 ? 0 : 1);
                    var G = Number(h * o) - (o == 0 ? 0 : 1);
                    var B = Number(h * g) - (g == 0 ? 0 : 1);
                    var v = this.toolDNum(R.toString(16)) +
                        "" +
                        this.toolDNum(G.toString(16)) +
                        "" +
                        this.toolDNum(B.toString(16));
                    var u = e.insertCell(o);
                    u.width = "10px";
                    u.innerHTML = "&nbsp;";
                    u.title = v.toUpperCase();
                    u.style.backgroundColor = "#" + v;
                    u._bg = "#" + v;
                    if (this.val != null &&
                        "#" + v.toUpperCase() == this.val.toUpperCase()) {
                        u.style.border = "2px solid white";
                    }
                }
            }
        }
    };
    eXcell_cp.prototype.getValue = function () {
        return this.cell.firstChild._bg || "";
    };
    eXcell_cp.prototype.getRed = function () {
        return Number(parseInt(this.getValue().substr(1, 2), 16));
    };
    eXcell_cp.prototype.getGreen = function () {
        return Number(parseInt(this.getValue().substr(3, 2), 16));
    };
    eXcell_cp.prototype.getBlue = function () {
        return Number(parseInt(this.getValue().substr(5, 2), 16));
    };
    eXcell_cp.prototype.detach = function () {
        if (this.obj.offsetParent != null) {
            document.body.removeChild(this.obj);
        }
        return this.val != this.getValue();
    };
    return eXcell_cp;
})(eXcell);
eXcell_cp.prototype.setValue = function (a) {
    this.setCValue("<div style='width:100%;height:" +
        (this.grid.multiLine ? "100%" : 23) +
        ";background-color:" +
        (a || "") +
        ";border:0px;'>&nbsp;</div>", a);
    this.cell.firstChild._bg = a;
};

window.eXcell_cp = eXcell_cp;
export default eXcell_cp;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_cp.js